import { Button } from '@cian/ui-kit';
import { Filters16 } from '@cian/ui-kit/prev/icons';
import * as React from 'react';

import * as styles from './UtilityFiltersContainer.css';

export const UtilityFiltersContainer = () => {
  const handleClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.preventDefault();

    const searchString = window.location.search;

    setTimeout(() => {
      document.cookie = 'flavour=mobile;domain=.cian.ru;path=/';
      window.location.href = `/nd/search/${searchString}`;
    }, 300);
  }, []);

  return (
    <div className={styles['button']}>
      <Button size="XS" theme="fill_white_primary" beforeIcon={<Filters16 color="primary_100" />} onClick={handleClick}>
        Фильтры
      </Button>
    </div>
  );
};
